import React, { Component } from 'react';

import Branches from './Branches.js';
import Questions from './Questions.js';

import { getTranslation } from '../../Utilities/GetTranslation.js'

class Project extends Component {

    isValidated() {
        // Validate the "sub" tabs
        var valid = true;
        valid = valid && (typeof this.refs.branches.isValidated === "undefined" || this.refs.branches.isValidated());
        valid = valid && (typeof this.refs.questions.isValidated === "undefined" || this.refs.questions.isValidated());

        return valid;
    }

    render() { 
        return (
            <div>
                <p><em dangerouslySetInnerHTML={{ __html: (this.props.job.appTextProject === "") ? getTranslation("sns.webparts.project.sub") : this.props.job.appTextProject }} /></p>
                <Branches ref="branches" job={this.props.job} />
                <Questions ref="questions" job={this.props.job} />
            </div>
        );
    }
}

export default Project;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Project.js